module.exports = __webpack_public_path__ + "895a24a5b1c99af8042d9cde97d482bf.png";